/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Autocomplete,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  createFilterOptions,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
} from '@mui/material';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useParams } from 'react-router';
import { useForm, Controller } from 'react-hook-form';

import { MATERIAL_TRANSACTION_TYPE } from '../../../utils/constants';
import dayjs from '../../../utils/functions/thDayjs';
import CustomerForm from '../Customer/CustomerForm';
import { DatePicker } from '../../Datepicker';

export function MaterialStockForm({
  errors,
  Controller,
  control,
  placeaddstock,
  materialTransactionType,
  customer,
  department,
  me,
  type,
  setType,
  setFilterPlace,
  setSelectMaterial,
  setSelectMaterialLot,
  customerType,
  handleCreateCustomer,
}) {
  const { id } = useParams();
  const information = useSelector((state) => state.information);
  const {
    setting: { ims: imsSetting },
  } = information;

  const {
    handleSubmit: createCustomerHandleSubmit,
    formState: { errors: createCustomerError },
    control: createCustomerControl,
  } = useForm();
  const filter = createFilterOptions();

  const [isModalCreateCustomerOn, setIsModalCreateCustomerOn] = useState(false);
  const [createdCustomerName, setCreatedCustomerName] = useState('');

  const checkType = (data) => {
    const findType = _.find(materialTransactionType, { _id: data });
    setType(findType);
    setSelectMaterial([]);
  };
  const checkPlace = () => {
    const findPlacetest = _.find(placeaddstock, { _id: id });
    return findPlacetest;
  };

  return (
    <div className="flex flex-row flex-wrap">
      <div className="w-full lg:w-1/2">
        <div className="w-full px-1 py-2">
          {!_.isEmpty(placeaddstock) && (
            <Controller
              name={'place'}
              control={control}
              defaultValue={checkPlace() || placeaddstock?.[1]}
              rules={{ required: true }}
              render={({ field }) => (
                <Autocomplete
                  size={'small'}
                  {...field}
                  onChange={(e, newValue) => {
                    field.onChange(newValue);
                  }}
                  options={placeaddstock}
                  getOptionLabel={(option) => option?.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="คลัง"
                      required
                      helperText={errors?.place && 'กรุณาระบุคลังวัสดุ'}
                    />
                  )}
                />
              )}
            />
          )}
        </div>
        <div className="w-full px-1 py-2">
          <Controller
            name={'material_transaction_type'}
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <FormControl sx={{ minWidth: 120 }} fullWidth={true} required>
                <InputLabel id="type" size={'small'}>
                  ประเภทการดำเนินการ
                </InputLabel>
                <Select
                  {...field}
                  label="ประเภทการดำเนินการ"
                  size={'small'}
                  fullWidth
                  onChange={(e) => {
                    field.onChange(e.target.value);
                    checkType(e.target.value);
                  }}
                >
                  {_.size(materialTransactionType) ? (
                    _.map(
                      materialTransactionType,
                      (_materialTransactionType) => (
                        <MenuItem
                          key={_materialTransactionType._id}
                          value={_materialTransactionType._id}
                        >
                          {_materialTransactionType?.direction === 'sell' ? (
                            <i className="fas mr-2 fa-arrow-circle-left"></i>
                          ) : (
                            <i className="fas mr-2 fa-arrow-circle-right"></i>
                          )}{' '}
                          {_materialTransactionType.name}
                        </MenuItem>
                      ),
                    )
                  ) : (
                    <MenuItem>
                      <MenuItem disabled value="">
                        <em>ไม่มีข้อมูล</em>
                      </MenuItem>
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            )}
          />
        </div>
      </div>
    </div>
  );
}

MaterialStockForm.propTypes = {
  errors: PropTypes.shape({
    material_transaction_type: PropTypes.object,
    bill_number: PropTypes.object,
    supplier: PropTypes.object,
    source: PropTypes.object,
    place: PropTypes.object,
    purchase_date: PropTypes.object,
    receipt_date: PropTypes.object,
    issue_date: PropTypes.object,
    remark: PropTypes.object,
    recipient_name: PropTypes.object,
    order_department: PropTypes.object,
    request_department: PropTypes.object,
    request_name: PropTypes.object,
  }),
  materialTransactionType: PropTypes.object,
  place: PropTypes.object,
  customer: PropTypes.object,
  department: PropTypes.object,
  me: PropTypes.object,
  type: PropTypes.object,
  setType: PropTypes.func,
  setFilterPlace: PropTypes.func,
  setSelectMaterial: PropTypes.func,
  setSelectMaterialLot: PropTypes.func,
  Controller: PropTypes.func,
  control: PropTypes.object,
  customerType: PropTypes.arrayOf(PropTypes.object),
  handleCreateCustomer: PropTypes.func,
};

MaterialStockForm.defaultProps = {
  materialTransactionType: null,
  place: null,
  customer: null,
  department: null,
  me: null,
  type: null,
  filterPlace: null,
};

export default MaterialStockForm;
